import * as i0 from "@angular/core";
import * as i1 from "../webgl2/webgl2.directive";
import * as i2 from "../webgl2/scene-loader";
import * as i3 from "../game-engine/render-loop";
import * as i4 from "./canvas-controller.directive";
import * as i5 from "../game-engine/input-manager";
import * as i6 from "./main-canvas.component";
var styles_MainCanvas = ["canvas[_ngcontent-%COMP%] {\n        height: 100%;\n        width: 100%;\n        border: none;\n        position: absolute;\n        z-index: 0;\n    }"];
var RenderType_MainCanvas = i0.ɵcrt({ encapsulation: 0, styles: styles_MainCanvas, data: {} });
export { RenderType_MainCanvas as RenderType_MainCanvas };
export function View_MainCanvas_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { webgl_context: 0 }), (_l()(), i0.ɵted(-1, null, ["\n    "])), (_l()(), i0.ɵeld(2, 0, null, null, 4, "canvas", [["canvas-controller", ""], ["webgl2", ""]], [[8, "width", 0], [8, "height", 0]], [[null, "webglcontextlost"], [null, "webglcontextrestored"], [null, "mouseenter"], [null, "mouseleave"], [null, "contextmenu"], [null, "wheel"], [null, "mouseup"], [null, "mousedown"], [null, "keydown"], [null, "keyup"], [null, "mousemove"]], function (_v, en, $event) { var ad = true; if (("webglcontextlost" === en)) {
        var pd_0 = (i0.ɵnov(_v, 3).onContextLost($event) !== false);
        ad = (pd_0 && ad);
    } if (("webglcontextrestored" === en)) {
        var pd_1 = (i0.ɵnov(_v, 3).onContextRestored($event) !== false);
        ad = (pd_1 && ad);
    } if (("mouseenter" === en)) {
        var pd_2 = (i0.ɵnov(_v, 4).setFocus($event) !== false);
        ad = (pd_2 && ad);
    } if (("mouseleave" === en)) {
        var pd_3 = (i0.ɵnov(_v, 4).lostFocus($event) !== false);
        ad = (pd_3 && ad);
    } if (("contextmenu" === en)) {
        var pd_4 = (i0.ɵnov(_v, 4).hideContextMenu() !== false);
        ad = (pd_4 && ad);
    } if (("wheel" === en)) {
        var pd_5 = (i0.ɵnov(_v, 4).onMouseWheel($event) !== false);
        ad = (pd_5 && ad);
    } if (("mouseup" === en)) {
        var pd_6 = (i0.ɵnov(_v, 4).setMouseUp($event) !== false);
        ad = (pd_6 && ad);
    } if (("mousedown" === en)) {
        var pd_7 = (i0.ɵnov(_v, 4).setMouseDown($event) !== false);
        ad = (pd_7 && ad);
    } if (("keydown" === en)) {
        var pd_8 = (i0.ɵnov(_v, 4).onKeyDown($event) !== false);
        ad = (pd_8 && ad);
    } if (("keyup" === en)) {
        var pd_9 = (i0.ɵnov(_v, 4).onKeyUp($event) !== false);
        ad = (pd_9 && ad);
    } if (("mousemove" === en)) {
        var pd_10 = (i0.ɵnov(_v, 4).setMouseMovement($event) !== false);
        ad = (pd_10 && ad);
    } return ad; }, null, null)), i0.ɵdid(3, 147456, [[1, 4]], 0, i1.Webgl2Directive, [i0.ElementRef, i2.GLTFLoader, i3.RenderLoop], null, null), i0.ɵdid(4, 475136, null, 0, i4.CanvasController, [i5.InputManager, i0.ElementRef], null, null), (_l()(), i0.ɵeld(5, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i0.ɵted(6, null, ["", ""])), (_l()(), i0.ɵted(-1, null, ["\n    "]))], function (_ck, _v) { _ck(_v, 4, 0); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = i0.ɵnov(_v, 4).canvas_width; var currVal_1 = i0.ɵnov(_v, 4).canvas_height; _ck(_v, 2, 0, currVal_0, currVal_1); var currVal_2 = _co.fallback_text; _ck(_v, 6, 0, currVal_2); }); }
export function View_MainCanvas_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "main-canvas", [], null, null, null, View_MainCanvas_0, RenderType_MainCanvas)), i0.ɵdid(1, 4243456, null, 0, i6.MainCanvas, [], null, null)], null, null); }
var MainCanvasNgFactory = i0.ɵccf("main-canvas", i6.MainCanvas, View_MainCanvas_Host_0, {}, {}, []);
export { MainCanvasNgFactory as MainCanvasNgFactory };
//# sourceMappingURL=main-canvas.component.ngfactory.js.map